import { ImageRepository } from './domain/repositories/ImageRepository'
import { FetchImageRepository } from './infrastructure/repositories/FetchImageRepository'
import { ImageUploaderStateMachineInterpreter } from './machines/ImageUploaderMachine'

export type ImageUploaderMachineInterpreterFactory = (
  campsiteSlug: string,
  token: string,
  langCode: string,
) => ImageUploaderStateMachineInterpreter

export type ImageRepositoryFactory = (
  campsiteSlug: string,
  token: string,
  langCode: string,
) => ImageRepository

// tslint:disable variable-name
export const IImageRepositoryFactory = Symbol('FetchImageRepositoryFactory')

export const fetchImageRepositoryFactory = () => {
  return (campsiteSlug: string, token: string, langCode: string) => {
    return new FetchImageRepository(campsiteSlug, token, langCode)
  }
}
